const MatchRouter = {
  path: '/match',
  name: 'Match',
  redirect: '/match/home',
  component: () => import('@/views/match/index'),
  children: [
    {
      path: 'home',
      name: 'MatchHome',
      component: () => import('@/views/match/home'),
      meta: {
        title: '赛事主页'
      }
    },
    {
      path: 'standings',
      name: 'MatchStandings',
      component: () => import('@/views/match/standings'),
      meta: {
        title: '积分榜'
      }
    },
    {
      path: 'MatchSchedule',
      name: 'Schedule',
      component: () => import('@/views/match/schedule'),
      meta: {
        title: '赛程表'
      }
    },
    {
      path: 'player-list',
      name: 'MatchPlayerList',
      component: () => import('@/views/match/player-list'),
      meta: {
        title: '赛事球员榜'
      }
    },
    {
      path: 'info',
      name: 'MatchInfo',
      component: () => import('@/views/match/info'),
      meta: {
        title: '赛事信息'
      }
    },
    {
      path: 'team-list',
      name: 'MatchTeamList',
      component: () => import('@/views/match/team-list'),
      meta: {
        title: '球队数据'
      }
    },
    {
      path: 'match-ranking',
      name: 'MatchRanking',
      component: () => import('@/views/match/match-ranking.vue'),
      meta: {
        title: '赛事名次'
      }
    },
    {
      path: 'basketball-data',
      name: 'BasketballData',
      component: () => import('@/views/match/basketball-data.vue'),
      meta: {
        title: '赛事数据'
      }
    },
    {
      path: 'attend-match-player',
      name: 'AttendPlayer',
      component: () => import('@/views/match/attend-match-player.vue'),
      meta: {
        title: '参赛名单'
      }
    },
    {
      path: 'my-data',
      name: 'MatchMyData',
      component: () => import('@/views/match/my-data/index.vue'),
      meta: {
        title: '我的数据'
      }
    },
    {
      path: 'match-data/:matchId',
      name: 'MatchMatchData',
      component: () => import('@/views/match/my-data/match-data.vue'),
      meta: {
        title: '赛事数据'
      }
    },
    {
      path: 'user-list/:accountId',
      name: 'MatchUserList',
      component: () => import('@/views/match/my-data/user-list.vue'),
      meta: {
        title: '我的队员'
      }
    },
    {
      path: 'baseball-data',
      name: 'BaseballData',
      component: () => import('@/views/match/baseball-data.vue'),
      meta: {
        title: '球员榜'
      }
    }
  ]
}
export default MatchRouter
